(() => {
  angular
    .module('complianceFrameworkApp.vms')
    .controller('AssessmentDetailController', AssessmentDetailController);

  /* ngInject */
  function AssessmentDetailController($stateParams, Flash, assessmentService, assessmentHistoryService, notificationSettingsService, sessionService, vendorService)  {
    const vm = this;

    vm.assessment = {};
    vm.assessmentHistories = [];
    vm.notificationSettings = {};
    vm.updateAssessmentSchedule = updateAssessmentSchedule;
    vm.vendor = {};
    vm.vendorId = $stateParams.vendorId;

    activate();

    function activate() {
      getAssessment();
      getAssessmentHistories();
      getNotificationSettings();
      getVendor();
    }

    function getAssessment() {
      assessmentService(sessionService.getAuthToken()).get({ id: vm.vendorId }, response => vm.assessment = response);
    }

    function getAssessmentHistories() {
      assessmentHistoryService(sessionService.getAuthToken()).query({ vendorId: vm.vendorId }, response => vm.assessmentHistories = response);
    }

    function getNotificationSettings() {
      notificationSettingsService(sessionService.getAuthToken()).get({}, response => vm.notificationSettings = response.notificationSettings);
    }

    function getVendor() {
      vendorService(sessionService.getAuthToken()).get({ id: vm.vendorId }, response => vm.vendor = response);
    }

    function updateAssessmentSchedule() {
      assessmentService(sessionService.getAuthToken()).update_schedule({ id: vm.vendorId }, vm.assessment, _ => {
        Flash.create('success', 'Assessment schedule was successfully updated.');
      });
    }
  }
})();
